module.exports = __webpack_public_path__ + "static/media/ananya.61d0371b.webp";